/* eslint-disable camelcase */
import { useSelector } from 'react-redux'

import { en_us, pt_br } from '../i18n'
import { IReduxReducers } from '../store'

export function useBowtieLanguage(): (text: string) => string {
    const { language } = useSelector((state: IReduxReducers) => state.bowtieLanguage)

    return (text: string) => {
        if (language === 'en_us' && en_us.values[text]) {
            return en_us.values[text]
        }

        if (language === 'pt_br' && pt_br.values[text]) {
            return pt_br.values[text]
        }

        return text
    }
}
